// extracted by mini-css-extract-plugin
export default {"title":"dM_cX","titleNonTransparent":"dM_mX","container":"dM_g","contentWrapper":"dM_mY","backgroundImage":"dM_dT"};